define([], function() {
    'use strict';
    return function(object) {
        return object instanceof RegExp;
    };
});
